import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import breadImage34 from "../assets/image/SHMUEL_ABOUT.jpg";
import breadImage29 from "../assets/newimages/Sulla Bread (29).jpg";
import breadImage31 from "../assets/newimages/Sulla Bread (31).jpg";
import "./AboutDetail.css";


const AboutDetail: React.FC = () => {
  const { t, i18n } = useTranslation();

  //גלילה ללמעלה
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <CurvedAccent className="curved-accent" /> */}

      <div className="about-detail-container" data-language={i18n.language} lang={i18n.language === "he" ? "he" : "ru"}>
        {/* Top Section - Text Left, Image Right */}
        <section className="about-detail-section">
          <div className="about-detail-content-wrapper">
            <div className="about-detail-text-column">
              <h1 className="about-detail-title">{t("aboutPageTitle")}</h1>
              <div className="about-detail-text-block">
                <p>{t("aboutPageText1")}</p>
              </div>
              <div className="about-detail-text-block">
                <p>{t("aboutPageText2")}</p>
              </div>
            </div>
            <div className="about-detail-image-column">
              <img
                src={breadImage34}
                alt={t("aboutImageAlt")}
                className="about-detail-image rounded-top"
              />
            </div>
          </div>
        </section>

        {/* Middle Section - Image Left, Text Right */}
        <section className="about-detail-section">
          <div className="about-detail-content-wrapper">
            <div className="about-detail-image-column">
              <img
                src={breadImage29}
                alt={t("aboutImageAlt")}
                className="about-detail-image rounded-bottom"
              />
            </div>
            <div className="about-detail-text-column">
              <div className="about-detail-text-block">
                <p>{t("aboutPageText3")}</p>
              </div>
              <div className="about-detail-text-block">
                <p>{t("aboutPageText4")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Bottom Section - Text Left, Image Right */}
        <section className="about-detail-section">
          <div className="about-detail-content-wrapper">
            <div className="about-detail-text-column">
              <div className="about-detail-text-block">
                <p>{t("aboutPageText5")}</p>
              </div>
              <div className="about-detail-text-block">
                <p>{t("aboutPageText6")}</p>
              </div>
            </div>
            <div className="about-detail-image-column">
              <img
                src={breadImage31}
                alt={t("aboutImageAlt")}
                className="about-detail-image rounded-bottom"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutDetail;
